import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const FilterByOutlet = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByOutletId }
  } = localizedStrings;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request.get('/get-outletIds');
      if (result) {
        const transformedResult = _.get(result, 'data.outletIds', [])
          .map(item => ({
            label: item.outlet,
            value: item.outlet
          }))
          .filter(row => !!row.value);
        setOptions(transformedResult);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, outletId: value });
        }}
        label={filterByOutletId}
        options={options}
        value={filters.outletId}
      />
    </div>
  );
};

FilterByOutlet.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByOutlet;
